/**
 * Paleta de los informes PDF. Tono institucional y sobrio (cliente: Generalitat
 * de Catalunya; emissor: UTE Eix Transversal C-25).
 *
 * - Acentos por tipo (`garnet`/`blueOT`/`blueAction`/`redAccident`/`orange`):
 *   desaturados respecto a los originales para impresión seria. `garnet` pasa a
 *   ser un granate REAL (#7A2E3A); antes estaba mapeado a #686890, un
 *   azul-violeta, incoherente con su nombre.
 * - Neutros: `ink` (texto principal), `greyDark` (secundario), `greyMid`
 *   (líneas), `grey`/`greyLight` (fondos suaves).
 */
export const PDF_COLORS = {
  // Acentos por tipo de entidad
  garnet: '#7A2E3A',
  blueOT: '#0B5563',
  blueAction: '#176C84',
  redAccident: '#B23A33',
  green: '#3E8E5A',
  orange: '#C06A12',
  // Neutros
  white: '#FFFFFF',
  black: '#1A1A1A',
  ink: '#222831',
  grey: '#F2F3F5',
  greyLight: '#F7F8FA',
  greyMid: '#D5D9DE',
  greyDark: '#5A6068',
};

const TYPE_COLOR_MAP: Record<string, string> = {
  Action: PDF_COLORS.blueAction,
  Accident: PDF_COLORS.redAccident,
  Communication: PDF_COLORS.blueOT,
  Generic: PDF_COLORS.garnet,
  ActionBudgetItems: PDF_COLORS.orange,
  // V4 FR-2.5 (2026-05-27): SurveillanceRoute usa el garnet del DS (mismo
  // que Generic) — el RV es un tipo "infraestructura/operación" no clasificable
  // como Action/Accident/Communication.
  SurveillanceRoute: PDF_COLORS.garnet,
};

export const getTypeColor = (orderType: string): string =>
  TYPE_COLOR_MAP[orderType] ?? PDF_COLORS.garnet;
